import React, { useState, useEffect } from "react";
import "./UpcomingEvents.css";
import AOS from "aos";
import "aos/dist/aos.css";

const UpcomingEvents = () => {
  const [nextEvent, setNextEvent] = useState(null);
  const [daysRemaining, setDaysRemaining] = useState(0);

  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: true,
    });

    const fetchEvents = async () => {
      try {
        const response = await fetch("/data/events.json");
        const eventsData = await response.json();

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const upcomingEvents = eventsData.filter(
          (event) => new Date(event.date) >= today
        );

        if (upcomingEvents.length > 0) {
          upcomingEvents.sort((a, b) => new Date(a.date) - new Date(b.date));
          setNextEvent(upcomingEvents[0]);
        } else {
          setNextEvent(null);
        }
      } catch (error) {
        console.error("Fehler beim Laden der Events:", error);
      }
    };

    fetchEvents();
  }, []);

  useEffect(() => {
    if (!nextEvent) return;

    const calculateDaysRemaining = () => {
      const eventDate = new Date(nextEvent.date);
      const today = new Date();
      const difference = eventDate.getTime() - today.getTime();
      const days = Math.ceil(difference / (1000 * 60 * 60 * 24));
      setDaysRemaining(days > 0 ? days : 0);
    };

    calculateDaysRemaining();
    const interval = setInterval(calculateDaysRemaining, 1000 * 60 * 60);

    return () => clearInterval(interval);
  }, [nextEvent]);

  const formatEventDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('de-DE', options);
  };

  if (!nextEvent) {
    return (
      <div className="next-event-card" data-aos="fade-left" data-aos-delay="200">
        <h3 className="next-event-header">Nächstes Event</h3>
        <p className="event-title-card" style={{ marginTop: '2rem' }}>
          Aktuell sind keine neuen Events geplant.
        </p>
      </div>
    );
  }

  return (
    <div className="next-event-card" data-aos="fade-left" data-aos-delay="200">
      <h3 className="next-event-header">Nächstes Event</h3>
      <div className="event-details">
        <p className="event-title-card">{nextEvent.title}</p>
        <p className="event-date-card">{formatEventDate(nextEvent.date)}</p>
      </div>
      <div className="countdown-card">
        <span className="days-card">{daysRemaining}</span>
        <span className="label-card">Tage bis zum Event</span>
      </div>
    </div>
  );
};

export default UpcomingEvents;
